import { Component, OnDestroy } from '@angular/core';
import { BreadcrumbService } from '../../../../providers/services/breadcrumb.service';
import { Breadcrumb } from '../../../../models/breadcrumb';
import { Router, RouterLink } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject} from 'rxjs';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'pdp-breadcrumbs',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    imports: [NgIf, RouterLink, NgFor]
})
export class BreadcrumbComponent implements OnDestroy {

  public platformBreadcrumbs: Breadcrumb[];
  private unsubscribe: Subject<void> = new Subject();


  constructor(public breadcrumbService: BreadcrumbService,
              public router: Router) {
    breadcrumbService.breadcrumbs
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(e => {
      this.platformBreadcrumbs = e;
    });
  }


  goBack() {
    if (document.referrer.indexOf('search') > - 1) {
      // http://localhost:9090/search?q=ka&page=0&size=30&sortBy=price&sortOrder=asc
      window.history.back();
    } else {
      // we came to this url (example url http://localhost:9090/search/itm/canon-kalkulator-kc-30-pp?itm=637) from another site or just opened browser, in that case
      // just redirect to search without ?q= param so client can enter search criteria again
      this.router.navigate(['/search']);
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
